
const S_MENU = '.js-menu';
const A = 'active';
const D = document;
let menu = D.querySelector(S_MENU)

const stop = function (e) {
  if(e){
    e.preventDefault && e.preventDefault();
    (e.stopPropagation) ? e.stopPropagation() : e.cancelBubble = true;
  }
}

const clickoutMenu = function () {
  /**
   * Тут клик по DOM, не нужно останавливать событие
   */
  clickMenu()
}

const clickMenu = function (e) {
  stop(e)
  let active = menu.classList.contains(A);
  if(active){
    menu.classList.remove(A)
    D.removeEventListener('click', clickoutMenu)
  }else{
    menu.classList.add(A)
    on(D, 'click', clickoutMenu);
  }
}

export default function () {
  on(menu, 'click', clickMenu);
}
